import React, { useReducer, createContext } from "react";

export const MainContext = createContext();

const initialState = [];

const reducer = (state, action) => {
  switch (action.type) {
    case "DATA_RESPONSE":
      return action.payload.value;
    case "UPDATED_CHECKED":
      return [...state];
    default:
      throw new Error();
  }
};

export const MainContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <MainContext.Provider value={[state, dispatch]}>
      {props.children}
    </MainContext.Provider>
  );
};
